import { ReactComponent as SettingsIcon } from './settings.svg';

export default SettingsIcon;
